import { Modal, ModalTitle, ModalBody, ModalFooter} from "@vds/modals";
import { Button, TextLink } from '@vds/buttons';
import React, { useState } from "react";

function OpenPerksModal(props) {

  const { onClick = () => { }, onClose = () => { }, opened = false } = props;
  const [showModal, setshowModal] = useState(false);

  const handleClose=() => {
    console.log('DEBUG: handleClose', onClose());
    onClose(false);
  }
  
  return (
    <>
      <Modal
        opened={opened}
        closeButton={null}
        fullScreenDialog={false}
        disableOutsideClick={false}
        id="mnTooltip-Modal"
      >
        <ModalTitle className="center">Max Premium - Netflix-Max</ModalTitle>
        <ModalBody>{props.message}</ModalBody>
        <ModalFooter
          buttonData={{
            close: {
              children: "Close",
              onClick: () => handleClose(),
            },
          }}
        />
      </Modal>
    </>
  );
}
export default OpenPerksModal;